import { render } from "./InventorySupplierView.vue?vue&type=template&id=7c7e5cbf"
import script from "./InventorySupplierView.vue?vue&type=script&lang=js"
export * from "./InventorySupplierView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__